import React from 'react';

const DancingDotsProgress = ({ percentage, height = 'h-2', className = '' }) => {
    return (
        <div className={`w-full ${height} bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden ${className}`}>
            <div
                className="bg-plantlix-600 dark:bg-plantlix-500 h-full rounded-full transition-all duration-300"
                style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
            />
        </div>
    );
};

export default DancingDotsProgress;
